export default "__VITE_ASSET__0ZswvuIl__"